module.exports = __webpack_public_path__ + "img/巴豆.281642c8.jpg";